import { render, staticRenderFns } from "./ozetGorunum.vue?vue&type=template&id=6d4f8023&scoped=true&"
import script from "./ozetGorunum.vue?vue&type=script&lang=js&"
export * from "./ozetGorunum.vue?vue&type=script&lang=js&"
import style0 from "./ozetGorunum.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ozetGorunum.vue?vue&type=style&index=1&id=6d4f8023&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4f8023",
  null
  
)

export default component.exports